import React from "react";
import PropTypes from "prop-types";

function EventTintButton({ icon, children, onClick, event }) {
    return (
        <div
            className="btn d-flex flex-row align-items-center justify-content-center"
            onClick={ onClick }
            style={{
                cursor: onClick ? "pointer" : "default",
                backgroundColor: (event?.tintColor ?? "#fae33d"),
                color: (event?.buttonTextColor ?? "black"),
            }}
        >
            <i className={ icon }/>
            { children }
        </div>
    );
}
EventTintButton.propTypes = {
    icon: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    event: PropTypes.object.isRequired,
};

export default React.memo(EventTintButton);
